import "./AlertDialogComponent.scss";
import {IComponentOptions, IFilterService, IOnDestroy, IOnInit, IScope} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {AlertDialogStoreFactory} from "../store/AlertDialogStoreFactory";
import {TfPriceFilter} from "../../../../types/AngularJS";
import {Observable, ReplaySubject} from "rxjs";
import {AlertDialogStore} from "../store/AlertDialogStore";
import {TradingAlertDefinition} from "../../../models/alert/TradingAlert";
import {CodeAndExchange} from "../../../../instruments/types/CodeAndExchange";
import {ObjectUtil} from "../../../../js/util/ObjectUtil";

export const AlertDialog = "tfTradingAlertDialog";

interface Resolve {
    alert?: TradingAlertDefinition;
}

export function alertDialog(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/dialog/AlertDialogComponent.html`,
        controllerAs: "ctrl",
        controller: AddAlertDialogComponentController,
        bindings: {
            resolve: "<",
            modalInstance: "<"
        }
    };
}

export class AddAlertDialogComponentController implements IOnInit, IOnDestroy {

    public readonly resolve: Resolve;
    public readonly modalInstance: IModalInstanceService;

    public store: AlertDialogStore;
    public security$: Observable<CodeAndExchange>;
    public hasRules$: Observable<boolean>;
    public description: string;

    private readonly priceFilter: TfPriceFilter;

    private readonly save$ = new ReplaySubject<boolean>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope,
                       private alertDialogStoreFactory: AlertDialogStoreFactory,
                       private $filter: IFilterService) {
        this.priceFilter = this.$filter("price");
    }

    public $onInit(): void {
        this.store = this.alertDialogStoreFactory(this.resolve.alert);
        this.security$ = this.store.security;
        this.store
            .description
            .takeUntil(this.destroyed$)
            .subscribe((description) => {
                this.$scope.$applyAsync(() => this.description = description);
            });
        this.save$
            .withLatestFrom(this.store.alert)
            .takeUntil(this.destroyed$)
            .subscribe(([_, alert]) => {
                this.modalInstance.close(alert);
            });
        this.hasRules$ = this.store
                             .rules
                             .map((rules) => rules.length)
                             .map((length) => length > 0);
    }

    public companyChanged(security: CodeAndExchange) {
        const copy = ObjectUtil.pick(security, "code", "exchange");
        this.store.updateSecurity(copy);
    }

    public save() {
        this.save$.next(true);
    }

    public updateDescription(description: string) {
        this.store.updateDescription(description);
    }

    public cancel() {
        this.modalInstance.dismiss();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
        this.store.destroy();
    }
}
